'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('../../../../components/Formatted/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _Mobile = require('./Mobile.scss');

var _Mobile2 = _interopRequireDefault(_Mobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Mobile = function (_PureComponent) {
    (0, _inherits3.default)(Mobile, _PureComponent);

    function Mobile() {
        (0, _classCallCheck3.default)(this, Mobile);
        return (0, _possibleConstructorReturn3.default)(this, (Mobile.__proto__ || (0, _getPrototypeOf2.default)(Mobile)).apply(this, arguments));
    }

    (0, _createClass3.default)(Mobile, [{
        key: 'render',
        value: function render() {
            return (0, _jsx3.default)('div', {
                className: _Mobile2.default.mobile
            }, void 0, (0, _jsx3.default)('img', {
                src: 'https://p1.liveauctioneers.com/dist/images/IPhone_Small.png',
                alt: 'mobile'
            }), (0, _jsx3.default)('span', {
                className: _Mobile2.default.header
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'bid_anywhere_anytime'
            })), (0, _jsx3.default)('a', {
                className: _Mobile2.default['app-store-link'] + ' ' + _Mobile2.default.ios,
                href: 'https://itunes.apple.com/us/app/live-auctions/id321243082',
                target: 'blank',
                title: 'Available on the App Store'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'available_on_the_app_store'
            })), (0, _jsx3.default)('a', {
                className: _Mobile2.default['app-store-link'] + ' ' + _Mobile2.default.android,
                href: 'https://play.google.com/store/apps/details?id=com.liveauctioneers.and',
                target: 'blank',
                title: 'Android App on Google Play'
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'android_app_on_google_play'
            })));
        }
    }]);
    return Mobile;
}(_react.PureComponent);

exports.default = Mobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/LAFooter/Mobile/Mobile.js
// module id = S9mu
// module chunks = 60